import React, { useMemo } from "react"
import useAuth from "hooks/useAuth"

interface AuthorizationArguments {
  disabled: boolean
  permissions: (string | null)[] | null | undefined
  isSuperadmin: boolean | undefined
}
interface AuthorizationProps {
  required: string[]
  validators?: boolean[]
  any?: boolean
  children: (args: AuthorizationArguments) => any
}
const Authorization = ({
  required,
  validators,
  children,
  any,
}: AuthorizationProps) => {
  const auth = useAuth()
  const isSuperadmin = auth?.user?.isSuperadmin
  const permissions = auth?.permissions
  const isAuthorized = useMemo(
    () =>
      isSuperadmin
        ? true
        : required && any
        ? required.some(rp => permissions?.find(p => p?.match(rp)))
        : required && !any
        ? required.every(rp => permissions?.find(p => p?.match(rp)))
        : true,
    [permissions, any, isSuperadmin, required]
  )

  const isValid = useMemo(
    () => (validators ? validators.every(v => v) : true),
    [validators]
  )
  const renderComponent = isSuperadmin ? true : isAuthorized && isValid

  return (
    <>
      {children({
        disabled: renderComponent ? false : true,
        permissions,
        isSuperadmin,
      })}
    </>
  )
}

Authorization.defaultProps = {
  validators: [],
  required: [],
  any: false,
}
export default Authorization
